import { render } from "./Screen2.vue?vue&type=template&id=61e8ee9a&scoped=true"
import script from "./Screen2.vue?vue&type=script&lang=js"
export * from "./Screen2.vue?vue&type=script&lang=js"

import "./Screen2.vue?vue&type=style&index=0&id=61e8ee9a&lang=scss&scoped=true"
import "./Screen2.vue?vue&type=style&index=1&id=61e8ee9a&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e8ee9a"]])

export default __exports__